export default {
  navbar: {
    blocks: "区块",
    transactions: "交易",
    producers: "BP节点",
    holders: "持币人",
    dapps: "DApps"
  }
}
